/**
 * Calls a predicate function with the given data as the only argument.
 * @param data The data to check.
 * @param predicate The function to call with the data.
 * @returns The result of the predicate function.
 */
export function predicate<T>(data: T, predicate: (data: T) => boolean): boolean {
  return predicate(data);
}
